import {PricingItemSummary} from "./pricing-item-summary";

export class TableSummary {
    constructor(
        public labels?: string[],
        public subFamily?: string,
        public pricingItems?: PricingItemSummary[],
    ) {

    }


}
